import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsBoolean, IsOptional } from 'class-validator';
import { Types } from 'mongoose';

import { ToObjectId } from '../decorators';
import { IsObjectId } from '../validators';

export class DeleteInputModel {
  @ApiProperty({ type: String, format: 'bson' })
  @IsObjectId()
  @ToObjectId()
  public id!: Types.ObjectId;

  @ApiPropertyOptional()
  @IsBoolean()
  @IsOptional()
  public force?: boolean;
}
